module.exports = __webpack_public_path__ + "media/application/images/external-services/bandcamp-logo-b27f59a188aebb7c9f580a067081345b.svg";